import {
  api_ValidateSalesOrderBeforePlacing,
  api_UploadBankTransferImage,
  api_LoadBankTranferBase64,
  api_SaveSalesOrder,
} from "../../connection/api/api-checkout";
import {
  STORE_AUTO_PLACE_BANK_GUID,
  STORE_AUTO_PLACE_PAYMODE,
  STORE_AUTO_PLACE_ORDER,
  STORE_DineType,
  STORE_MERCHANT,
  ENTRY_MODE,
  TABLE_NO,
} from "../../database/store-names";
import {
  CONCAT_TEXT_LIMIT,
  COPY_ELEMENT_TEXT,
  HEADER_TAB_SETUP,
  KEY_GENERATOR,
} from "../../functions/funtion";
import {
  PT_ORDERSTATUS,
  PT_PAYMODE,
  PT_CART,
} from "../../routes/stack/paths/pt-cart";
import {
  GET_SET_STORED_DATA,
  Get_CustomerCSID,
} from "../../database/get-stored-data";
import {
  BuildVersion,
  CSP,
  currentver,
  ENCRYPT_STORAGE,
} from "../../config/config";
import { dto_selected_final_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_Customer, dto_CustomerAddress } from "../../classes/dto-customer";
import { PT_ADDRESSLIST, PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import { api_LoadMerchantForMID } from "../../connection/api/api-home";
import { SET_STORE_PAGE_URL } from "../../database/store-data";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { F_Fammily, Font } from "../../util/config-fonts";
import { dto_common } from "../../classes/dto-common";
import { PT_ORDERS } from "../../routes/stack/paths/pt-orders";
import { Colors } from "../../util/colors";
import ProgressBar from "react-bootstrap/ProgressBar";
import Alert from "../../components/Alert";
import React from "react";
import "../../styles/css/pg-cart-paymode.css";
import "../../styles/css/progressbar.css";
import { ToastMessage } from "../../components/toast-notification/toast";
import { GET_CART } from "../../database/get-stored-data";
import { resolveOrderDeliveryPhoneNo } from "../../functions/address-phone";
import { clearCartAfterOrderSuccess } from "../../functions/cart-cleanup";
import { applyLocalSalesOrderCalculation } from "../../functions/local-order-calculation";
import { getOrderDineType } from "../../functions/dine-type";

export default class Paymode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CashOnPickup: false,
      BankTransfer: false,
      CardonDelivery: false,
      DisplayBankTransfer: false,
      BankTransferAccountName: "",
      BankTransferAccountNumbers: [],
      showSubmitButton: false,
      IsOrderProcess: false,
      ProgressBarValue: 0,
      ProgressBarDisplay: "none",
      BankTransferBase64GUID: "",
      isDeliveredByThirdParty: false,
      selectedPaymode: 0,
    };
  }

  async componentDidMount() {
    dto_common.IsCash = 0;
    await GET_SET_STORED_DATA();
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const isDtPosOrQr = CSP === "DT" && entryMode === "QR";
    const autoPlaceFlag = ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_ORDER);
    const shouldAutoPlaceOrder =
      isDtPosOrQr &&
      autoPlaceFlag !== undefined &&
      autoPlaceFlag !== null &&
      autoPlaceFlag !== "";
    if (shouldAutoPlaceOrder) {
      const storedPaymode = ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_PAYMODE);
      if (
        storedPaymode === undefined ||
        storedPaymode === null ||
        storedPaymode === ""
      ) {
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_ORDER);
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_PAYMODE);
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_BANK_GUID);
      } else {
        const CSID = await Get_CustomerCSID();
        if (CSID === 0 || CSID === undefined) {
          await SET_STORE_PAGE_URL(PT_PAYMODE);
          this.props.navigate(PT_SIGNIN);
          return;
        }
        dto_common.IsCash = parseInt(storedPaymode);
        if (dto_common.IsCash === 4) {
          const bankGuid = ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_BANK_GUID);
          if (bankGuid) {
            this.setState({ BankTransferBase64GUID: bankGuid });
          }
        }
        const selectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
        const needsAddress = parseInt(selectedDineType) === 4;
        if (
          needsAddress &&
          (dto_CustomerAddress.AddressGuid === undefined ||
            dto_CustomerAddress.AddressGuid === "" ||
            dto_CustomerAddress.AddressGuid === 0)
        ) {
          await SET_STORE_PAGE_URL(PT_PAYMODE);
          this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "cart"));
          return;
        }
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_ORDER);
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_PAYMODE);
        ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_BANK_GUID);
        await this.orderPlace();
        return;
      }
    }
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Payment Method",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_CART);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
    await this.DineTypeWisePayMode();
    await this.isDelBythirdPartisTrue();
  }

  async isDelBythirdPartisTrue() {
    let selectedMID = parseInt(dto_selected_final_merchant_or_product.MID);
    let selectedMerchant = [];
    const SelectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    if (selectedMID === 76) {
      dto_common.MTYPE = "GR";
      dto_common.ZoneId = 1490;
      let data = await api_LoadMerchantForMID(SelectedDineType, selectedMID);
      let objData = JSON.parse(data);
      let MerchantInfo = JSON.parse(objData.MerchantInfo);
      selectedMerchant = MerchantInfo[0];
    } else {
      let merchants = ENCRYPT_STORAGE.getItem(STORE_MERCHANT);
      let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
      if (merchants === undefined && entryMode === "QR") {
        let data = await api_LoadMerchantForMID(
          SelectedDineType,
          selectedMID,
          true,
        );
        let objData = JSON.parse(data);
        let MerchantInfo = JSON.parse(objData.MerchantInfo);
        selectedMerchant = MerchantInfo[0];
      } else {
        let selectedMID = parseInt(dto_selected_final_merchant_or_product.MID);
        selectedMerchant = merchants.find(
          (merchant) => merchant.MID === selectedMID,
        );
      }
    }
    const isDeliveredByThirdParty =
      selectedMerchant && selectedMerchant.IDT !== undefined
        ? selectedMerchant.IDT
        : false;
    this.setState({ isDeliveredByThirdParty });
  }

  async DineTypeWisePayMode() {
    const SelectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
  

    let PayModes = dto_cart_checkout.PayModeTypes;
    var PayModeOgj = PayModes.split("|");
    let CashOnPickup,
      CardonDelivery,
      BankTransfer = false;
    if (SelectedDineType === 4) {
      var DeliveryPaymodes = PayModeOgj[0].split("_");
      for (let i = 0; i < DeliveryPaymodes.length; i++) {
        if (1 === parseInt(DeliveryPaymodes[i])) {
          CashOnPickup = true;
        }
        if (4 === parseInt(DeliveryPaymodes[i])) {
          BankTransfer = true;
        }
        if (6 === parseInt(DeliveryPaymodes[i])) {
          CardonDelivery = true;
        }
      }
    }
    if (SelectedDineType === 3) {
      var PickupPaymodes = PayModeOgj[1].split("_");
      for (let i = 0; i < PickupPaymodes.length; i++) {
        if (1 === parseInt(PickupPaymodes[i])) {
          CashOnPickup = true;
        }
        if (4 === parseInt(PickupPaymodes[i])) {
          BankTransfer = true;
        }
        if (6 === parseInt(PickupPaymodes[i])) {
          CardonDelivery = true;
        }
      }
    }
    const shouldDefaultCash = entryMode === "QR" && CashOnPickup === true;
    if (shouldDefaultCash) {
      dto_common.IsCash = 1;
    }
    this.setState({
      CashOnPickup: CashOnPickup,
      BankTransfer: BankTransfer,
      CardonDelivery: CardonDelivery,
      DisplayBankTransfer: false,
      showSubmitButton: shouldDefaultCash,
      IsOrderProcess: false,
      BankTransferBase64GUID: "",
      selectedPaymode: shouldDefaultCash ? 1 : 0,
    });
  }

  render() {
    let DineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const hideDineTypeForPos = CSP === "DT" && entryMode === "QR";

    return (
      <div
        className="payModeLayout fadeInUp animated"
        style={{
          marginBottom: 50,
          height: "100vh",
        }}
      >
        {/* <div className="payModeHeading">
          <p>{"Select Your Payment Method"}</p>
        </div> */}

        {/* Options */}
        <div>
          {/* Cash On Delivery */}
          <div
            className="payModeRow"
            style={{
              display: this.state.CashOnPickup ? "flex" : "none",
              cursor: "pointer",
            }}
            onClick={(e) => {
              this.CashMode();
            }}
          >
            <input
              type="radio"
              value={1}
              name="paymode"
              checked={this.state.selectedPaymode === 1}
              onChange={() => {}}
              style={{
                marginRight: 5,
                fontSize: Font.Heading,
                color: Colors.ThemeBGcolor,
                accentColor: Colors.ThemeBGcolor,
                cursor: "pointer",
              }}
            />
            <p>
              <i className="bi bi-cash-stack" />
              {hideDineTypeForPos
                ? "Cash"
                : dto_common.DineType === 4
                  ? "Cash On Delivery"
                  : "Cash On TakeAway"}
            </p>
          </div>

          {/* Card On Delivery */}
          <div
            className="payModeRow"
            style={{
              display: this.state.CardonDelivery ? "flex" : "none",
              cursor: "pointer",
            }}
            onClick={(e) => {
              this.CardMode();
            }}
          >
            <input
              type="radio"
              value={1}
              name="paymode"
              checked={this.state.selectedPaymode === 6}
              onChange={() => {}}
              style={{
                marginRight: 5,
                fontSize: Font.Heading,
                color: Colors.ThemeBGcolor,
                accentColor: Colors.ThemeBGcolor,
                cursor: "pointer",
              }}
            />
            <p>
              <i className="bi bi-credit-card-2-front" />
              {hideDineTypeForPos
                ? "Card"
                : dto_common.DineType === 4
                  ? "Card On Delivery"
                  : "Card On TakeAway"}
            </p>
          </div>

          {/* Bank Transfer */}
          <div
            className="payModeRow"
            style={{
              display: this.state.BankTransfer ? "flex" : "none",
              cursor: "pointer",
            }}
            onClick={(e) => {
              this.BankTransferDetails();
            }}
          >
            <input
              type="radio"
              value={1}
              name="paymode"
              checked={this.state.selectedPaymode === 4}
              onChange={() => {}}
              style={{
                marginRight: 5,
                fontSize: Font.Heading,
                color: Colors.ThemeBGcolor,
                accentColor: Colors.ThemeBGcolor,
                cursor: "pointer",
              }}
            />
            <p>
              {" "}
              <i className="bi bi-bank" />
              Bank Transfer
            </p>
          </div>
        </div>

        {/* bank transfer deets */}
        {this.state.DisplayBankTransfer ? (
          <div className="payModeBankCard fadeInUp animated">
            <p
              style={{
                textAlign: "center",
                fontFamily: F_Fammily.Medium,
              }}
            >
              {this.state.BankTransferAccountName}
            </p>
            {this.state.BankTransferAccountNumbers.map &&
              this.state.BankTransferAccountNumbers.map((item, i) => {
                var arrobaccountnumber = [];
                arrobaccountnumber = item.split("|");
                return (
                  <div key={KEY_GENERATOR()}>
                    <div style={{ flexDirection: "row" }}>
                      <p style={{ fontWeight: "bold" }}>
                        {arrobaccountnumber[0]}
                      </p>
                      <p
                        style={{ cursor: "pointer", gap: "2" }}
                        className={arrobaccountnumber[1]}
                        onClick={() => {
                          let rs = COPY_ELEMENT_TEXT({
                            classname: arrobaccountnumber[1],
                          });
                          if (rs) {
                            let v = document.getElementById(
                              arrobaccountnumber[1],
                            );
                            v.className = "bi bi-file-earmark-check-fill";
                            v.innerHTML = "Copied";
                            setTimeout(() => {
                              v.className = "bi bi-file-earmark";
                              v.innerHTML = "";
                            }, 1500);
                          }
                        }}
                      >
                        {arrobaccountnumber[1]}
                        {"   "}
                        <i
                          style={{
                            color: Colors.ThemeBGcolor,
                            marginLeft: "5px",
                            fontWeight: "bolder",
                          }}
                          className="bi bi-file-earmark"
                          id={arrobaccountnumber[1]}
                        />
                      </p>
                    </div>
                  </div>
                );
              })}

            {this.state.ProgressBarDisplay === "none" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center", // Center horizontally
                  justifyContent: "center", // Center vertically
                }}
              >
                <div
                  style={{
                    width: "fit-content",
                    color: "white",
                    backgroundColor: Colors.DarkGreyScale,
                    marginBottom: 5,
                    padding: "3% 6% 3% 6%",
                    cursor: "pointer",
                    textAlign: "center",
                    borderRadius: "8px",
                  }}
                  onClick={() => {
                    document.getElementById("UploadImagelocal").click();
                  }}
                >
                  Attach receipt
                </div>
                <p
                  style={{
                    fontWeight: "bold",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  Please attach a clear, uncropped screenshot of the receipt. Do
                  not attach captured, rotated, or altered image.
                </p>
              </div>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  color: "",
                  marginBottom: 5,
                  cursor: "pointer",
                }}
              >
                Image processing {"  "}
                <i className="fa fa-circle-o-notch fa-spin" />
              </p>
            )}

            <input
              type="file"
              accept="image/*"
              onChange={this.onFileChange}
              id="UploadImagelocal"
              style={{ display: "none" }}
            />
            <ProgressBar
              className="FadeIn Animated"
              animated
              variant="info"
              now={this.state.ProgressBarValue}
              label={`${this.state.ProgressBarValue}%`}
              style={{ display: this.state.ProgressBarDisplay }}
            />
            <img
              id="bankTranferImage"
              alt=""
              src={require("./images/Image-Upload.png")}
              style={{ width: "100%", cursor: "pointer" }}
              onClick={() => {
                document.getElementById("UploadImagelocal").click();
              }}
              onError={(e) => {
                e.currentTarget.src = require("./images/Image-Upload-Error.png");
                this.setState({
                  ProgressBarDisplay: "none",
                  BankTransferBase64GUID: "",
                  showSubmitButton: false,
                });
                return;
              }}
            />
          </div>
        ) : null}

        {/* Submit button */}
        {this.state.showSubmitButton ? (
          <>
            {!this.state.IsOrderProcess ? (
              <div>
                {this.state.isDeliveredByThirdParty === true &&
                DineType === 4 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "red",
                      marginTop: 20,
                      fontWeight: "bold",
                    }}
                  >
                    Note: Delivery of this order will be conducted and charged
                    separately by{" "}
                    {dto_selected_final_merchant_or_product.Merchant}
                  </div>
                ) : (
                  ""
                )}

                <button
                  style={{
                    fontFamily: F_Fammily.Medium,
                    backgroundColor: Colors.DarkGreyScale,
                    cursor: "pointer",
                  }}
                  className="payModeCODBtn fadeInUp animated"
                  onClick={async () => {
                    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
                    const isDtPosOrQr = CSP === "DT" && entryMode === "QR";
                    if (isDtPosOrQr) {
                      const CSID = await Get_CustomerCSID();
                      if (CSID === 0 || CSID === undefined) {
                        if (dto_common.IsCash === 4) {
                          if (this.state.BankTransferBase64GUID === "") {
                            // Alert.MessageBox({
                            //   Tittle: "Error",
                            //   Text: "Something went wrong with image upload",
                            //   ConfirmButtonText: "Ok",
                            // });
                            ToastMessage(
                              3,
                              "Something went wrong with image upload",
                            );
                            return;
                          }
                          ENCRYPT_STORAGE.setItem(
                            STORE_AUTO_PLACE_BANK_GUID,
                            this.state.BankTransferBase64GUID,
                          );
                        } else {
                          ENCRYPT_STORAGE.removeItem(
                            STORE_AUTO_PLACE_BANK_GUID,
                          );
                        }
                        ENCRYPT_STORAGE.setItem(STORE_AUTO_PLACE_ORDER, "1");
                        ENCRYPT_STORAGE.setItem(
                          STORE_AUTO_PLACE_PAYMODE,
                          dto_common.IsCash,
                        );
                        await SET_STORE_PAGE_URL(PT_PAYMODE);
                        this.props.navigate(PT_SIGNIN);
                        return;
                      }
                    }
                    await this.ValidateOrderType({
                      Function: async () => {
                        await this.orderPlace();
                      },
                    });
                  }}
                >
                  <i
                    className="bi bi-cart-check"
                    style={{ marginRight: "20px" }}
                  />
                  PLACE ORDER
                </button>
              </div>
            ) : (
              <button className="payModeCODBtn">
                <i className="fa fa-circle-o-notch fa-spin" />
              </button>
            )}
          </>
        ) : null}
      </div>
    );
  }

  async _base64ToArrayBuffer(base64) {
    var MaxSubString = 500000;
    var str = base64;
    var lst = [];
    for (;;) {
      if (str.length > 0) {
        lst.push(str.substring(0, MaxSubString));
        str = str.replace(str.substring(0, MaxSubString), "");
      } else {
        break;
      }
    }
    return lst;
  }

  onFileChange = async (event) => {
    const file = event.target.files[0];
    if (file !== undefined) {
      let type = file.type.includes("image");
      if (type) {
        const reader = new FileReader();
        var output = document.getElementById("bankTranferImage");
        output.src = require("./images/Image-Upload.png");
        this.setState({
          ProgressBarDisplay: "block",
          ProgressBarValue: 0,
          BankTransferBase64GUID: "",
          showSubmitButton: false,
        });

        reader.onloadend = async () => {
          //console.log(reader.result);
          // this.setState({ loading: true, ProgressbarDisplay: "flex" });
          var list = await this._base64ToArrayBuffer(reader.result.trim());
          var GUID = "";
          for (let j = 0; j < list.length; j++) {
            var value = parseInt((j / list.length) * 100);

            let x = "";

            if (list[j] !== undefined) {
              x = list[j].replace(/^data:image\/[a-z]+;base64,/, "");
            }

            if (list.length - 1 !== j) {
              let data = await api_UploadBankTransferImage(x, false, GUID);
              if (data !== undefined) {
                GUID = data;
                this.setState({ ProgressBarValue: value });
              }
            } else {
              this.setState({ ProgressBarValue: value });
              let data = await api_UploadBankTransferImage(x, true, GUID);
              if (data !== undefined) {
                GUID = data;
                // let n = BankTranferUrl + "testJson.json"; //+ data + ".txt";
                let ImageBase64 = await api_LoadBankTranferBase64(data);
                let objImageBase64 = JSON.parse(ImageBase64);
                if (ImageBase64 === "") {
                  // Alert.MessageBox({
                  //   Tittle: "Info",
                  //   Text: "Image size is too big. Please try to upload small size image",
                  // });
                  ToastMessage(
                    1,
                    "Image size is too big. Please try to upload small size image",
                  );
                  this.setState({
                    ProgressBarDisplay: "none",
                    BankTransferBase64GUID: "",
                    showSubmitButton: false,
                  });
                  return;
                }
                if (objImageBase64 === "Image Not Found") {
                  output.src = "#";
                  this.setState({
                    ProgressBarDisplay: "none",
                    BankTransferBase64GUID: "",
                    showSubmitButton: false,
                  });
                } else {
                  output.src = "data:image/jpeg;base64," + objImageBase64;

                  this.setState({
                    ProgressBarDisplay: "none",
                    BankTransferBase64GUID: data,
                    showSubmitButton: true,
                  });
                }
              }
            }
          }
          //output.src = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.setState({ ProgressBarDisplay: "none" });
      }
    }
  };

  CashMode() {
    dto_common.IsCash = 1;
    this.setState({
      DisplayBankTransfer: false,
      showSubmitButton: true,
      BankTransferBase64GUID: "",
      selectedPaymode: 1,
    });
  }

  CardMode() {
    dto_common.IsCash = 6;
    this.setState({
      DisplayBankTransfer: false,
      showSubmitButton: true,
      BankTransferBase64GUID: "",
      selectedPaymode: 6,
    });
  }

  BankTransferDetails() {
    let data = dto_cart_checkout.BankTransferAccountDetails;
    var obdata = data.split("µ");
    var arrobdata = [];
    for (let i = 0; i < obdata.length; i++) {
      if (i !== 0) {
        arrobdata.push(obdata[i]);
      }
    }
    dto_common.IsCash = 4;
    this.setState({
      BankTransferAccountName: obdata[0],
      BankTransferAccountNumbers: arrobdata,
      DisplayBankTransfer: true,
      showSubmitButton: false,
      BankTransferBase64GUID: "",
      selectedPaymode: 4,
    });
  }

  ValidateOrderType = async ({ Function: PlaceOrder }) => {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const hideDineTypeForPos = CSP === "DT" && entryMode === "QR";
    if (dto_common.DineType === 0) {
      // Alert.MessageBox({
      //   Tittle: "Info",
      //   Icon: "error",
      //   ConfirmButtonText: "OK",
      //   Text: "Please select Delivery or Pick Up",
      // });

      ToastMessage(3, "Please select Delivery or Pick Up");
      return;
    }
    if (parseInt(dto_common.DineType) === 4) {
      if (
        dto_CustomerAddress.AddressGuid === undefined ||
        dto_CustomerAddress.AddressGuid === ""
      ) {
        // Alert.MessageBox({
        //   Tittle: "Info",
        //   Icon: "info",
        //   ConfirmButtonText: "OK",
        //   Text: "Select your address",
        // });

        ToastMessage(1, "Select your address");
        return;
      }
      let Message =
        "<div class='ConfirmOrderType'>" +
        "<p>" +
        (hideDineTypeForPos
          ? "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:3px;'font-size: 18px; color: red;></i> Order "
          : dto_common.DineType === 4
            ? "<i class='fa fa-motorcycle' aria-hidden='true' style=margin:5px;'font-size: 18px; color: red;></i> Delivery Order "
            : "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:3px;'font-size: 18px; color: red;></i> Pick Up Order") +
        "</p>" +
        "</div>" +
        '<div class="confirmAdd">' +
        "<div>" +
        '<i class="bi bi-geo-alt-fill" aria-hidden="true" style="margin:3px;font-size: 18px;"></i>' +
        "</div>" +
        "<div>" +
        '<p style="margin:3px;font-size:15px;text-align:left;">' +
        dto_CustomerAddress.DefaultAdd1 +
        " " +
        dto_CustomerAddress.DefaultAdd2 +
        " " +
        dto_CustomerAddress.DefaultAdd3 +
        "</p>" +
        "</div>";
      if (dto_common.SCHEDULEDDATE !== "") {
        Message =
          "<div class='ConfirmOrderType'> " +
          "<p>" +
          (hideDineTypeForPos
            ? "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:3px;'font-size: 18px></i> Order "
            : dto_common.DineType === 4
              ? "<i class='fa fa-motorcycle' aria-hidden='true' style=margin:5px;'font-size: 18px></i> Delivery Order "
              : "<i class='bi bi-bag-fill' aria-hidden='true' style=margin:3px;'font-size: 18px></i> Pick Up Order") +
          "</p>" +
          "</div>" +
          '<div class="confirmAdd">' +
          "<div class='confirmAddIco'>" +
          '<i class="bi bi-geo-alt-fill" aria-hidden="true" style="margin:3px;font-size: 18px;"></i>' +
          "<i class='bi bi-calendar-check' aria-hidden='true' style=margin:3px;'font-size: 18px;'></i>" +
          "</div>" +
          "<div>" +
          '<p style="margin:3px;font-size:15px;text-align:left;margin-bottom: 15px;"> ' +
          dto_CustomerAddress.DefaultAdd1 +
          " " +
          dto_CustomerAddress.DefaultAdd2 +
          " " +
          dto_CustomerAddress.DefaultAdd3 +
          " " +
          "</p><div> <p style='font-size: 15px;margin:0px'>" +
          dto_common.SCHEDULEDTIME +
          "</p><p style='font-size: 15px;margin:0px'>" +
          dto_common.SCHEDULEDDATE +
          "</p></div>" +
          "</div>";
      }

      if (CSP === "AV") {
        Alert.ConfirmationMessageBox({
          Icon: "info",
          Tittle: "<b>Confirm</b>",
          Text: Message,
          ConfirmButtonText: "OK",
          CancelButtonMessage: "Change",
          ConfirmButtonFunction: async () => {
            await PlaceOrder();
          },
          DismissButtonFunction: async () => {},
        });
      } else {
        await PlaceOrder();
      }
    } else {
      const confirmTitle = hideDineTypeForPos ? "Confirm" : "Pick Up";
      const confirmText = hideDineTypeForPos
        ? "Are you sure you want to place the order?"
        : "<p>Your order will be ready in a while. <br/> <br/>  Please collect your order at " +
          dto_selected_final_merchant_or_product.Merchant +
          "</p>";
      if (CSP === "AV") {
        Alert.ConfirmationMessageBox({
          Icon: "info",
          Tittle: confirmTitle,
          Text: confirmText,
          ConfirmButtonText: "Confirm",
          CancelButtonMessage: "No",
          ConfirmButtonFunction: async () => {
            await PlaceOrder();
          },
          DismissButtonFunction: async () => {},
        });
      } else {
        await PlaceOrder();
      }
    }
  };

  async orderPlace() {
    this.setState({ IsOrderProcess: true }, async () => {
      if (dto_cart_checkout.Cart.length > 0) {
        const rawCart = (await GET_CART()) || [];
        await applyLocalSalesOrderCalculation({
          cart: rawCart,
          isChangePromo: false,
          customerPromoCount: 0,
        });
        let rs = await api_ValidateSalesOrderBeforePlacing();
        if (JSON.parse(rs) !== "SUCCESS") {
          this.setState({ IsOrderProcess: false });
          this.props.navigate(PT_ORDERS);
          setTimeout(() => {
            ToastMessage(1, rs);
          }, 0);
          return;
        }
        if (dto_common.IsCash === 4) {
          if (this.state.BankTransferBase64GUID === "") {
            ToastMessage(1, "Something went wrong with image upload");
            return;
          }
        }
        var SCHEDULEDORDER = false;

        if (dto_common.SCHEDULEDDATE === "") {
          SCHEDULEDORDER = false;
        } else {
          SCHEDULEDORDER = true;
        }
        if (parseInt(dto_common.DineType) !== 4) {
          dto_CustomerAddress.AddressGuid = 0;
        }
        const tableNo =
          CSP === "DT"
            ? String(ENCRYPT_STORAGE.getItem(TABLE_NO) || "").trim()
            : "";
        const dineTypeForOrder = getOrderDineType({
          dineType: dto_common.DineType,
          tableNo,
        });
        const deliveryPhoneNo = resolveOrderDeliveryPhoneNo();
        const InvSaveData = {
          SERVICENAME: "SaveSalesOrder",
          MOBILEPOSHEADER: [
            {
              GUIDAddress: parseInt(dto_CustomerAddress.AddressGuid), //GUIDAddress
              IsCash: parseInt(dto_common.IsCash), //IsCash,//IsCash - compaymode
              DeliveryCustomer: dto_Customer.CusName, //DeliveryCustomer
              DeliveryPhoneNo: deliveryPhoneNo, //DeliveryPhoneNo
              CSID: parseInt(dto_Customer.CSID), //CSID
              Company: "", //Company
              SubTotal: parseFloat(dto_cart_checkout.SubTotal), //SubTotal
              TaxTotal: parseFloat(dto_cart_checkout.TaxTotal), //TaxTotal,
              ServiceCharge: parseFloat(dto_cart_checkout.ServiceCharge), //ServiceCharge,
              CusName: dto_Customer.CusName, //CusName                 ,
              Comments:
                typeof dto_cart_checkout.Comment === "string"
                  ? dto_cart_checkout.Comment
                  : "", //Comments, if a string, use as is, otherwise, replace with empty string
              Add1: dto_CustomerAddress.DefaultAdd1, //Add3                    ,
              Add2: dto_CustomerAddress.DefaultAdd2, //Add2                    ,
              Add3: dto_CustomerAddress.DefaultAdd3, //Add1                    ,
              PhoneNo: dto_Customer.PhoneNo, //PhoneNo                 ,
              RowDiscountTotal: parseFloat(dto_cart_checkout.RowDiscountTotal), //RowDiscountTotal
              Total: parseFloat(dto_cart_checkout.Total), //Total
              DiscountTotal: parseFloat(dto_cart_checkout.DiscountTotal), //DiscountTotal - *
              MID: parseInt(dto_selected_final_merchant_or_product.MID), //MID
              Merchant: dto_selected_final_merchant_or_product.Merchant, //@Merchant
              DeviceName: "Web",
              DeliveryZoneID: parseInt(dto_common.DeliveryZoneID),
              ReleaseVersion: BuildVersion + " - " + currentver,
              DineType: dineTypeForOrder,
              TableNo: tableNo,
              DiscountPersentage: parseFloat(
                dto_cart_checkout.DiscountPersentage,
              ),
              BankTransferImageGUID: this.state.BankTransferBase64GUID,
              PromoGUID: parseInt(dto_cart_checkout.PromoGuid),
              PromoCode: dto_cart_checkout.PromoCODE,
              PUBLICIP: "192.168.1.1",
            },
          ],
          SQLDETAILSTRING: JSON.stringify(dto_cart_checkout.Cart),
          VERSION: BuildVersion,
          CSP: CSP,
          COUNTRYCODE: dto_common.NatvieCountry,
          COORDINATES: dto_common.CurrentCordinate,
          XMLTAXDOC: JSON.stringify(dto_cart_checkout.XMLTaxDoc),
          SCHEDULEDORDER: SCHEDULEDORDER,
          SCHEDULEDDATE: dto_common.SCHEDULEDDATE,
          SCHEDULEDTIME: dto_common.SCHEDULEDTIME,
          IPGGUID: "0",
          GUID: 0,
          REFPOSID: parseInt(0),
        };

        let data = await api_SaveSalesOrder(JSON.stringify(InvSaveData));
        let objResponse = JSON.parse(data.replace("#", ""));

        let status = "";
        let iserorr = "";
        if (objResponse.Error === null) {
          status = objResponse.GUNO;
          iserorr = "rquaste";
          await clearCartAfterOrderSuccess();
        } else {
          status = objResponse.Error;
          iserorr = "lquasfe";
        }
        this.setState({ IsOrderProcess: false });
        this.props.navigate(
          PT_ORDERSTATUS.replace(":status", status).replace(
            ":iserorr",
            iserorr,
          ),
        );
      } else {
        this.setState({ IsOrderProcess: false });
        ToastMessage(1, "No items in your cart");
      }
    });
  }
}
